























































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {loginModule} from '@/store/authentication/login';
import IconButton from '@/components/atom/button/IconButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import ToggleButtonField from '@/components/atom/input/ToggleButtonField.vue';
import WithdrawalModificationDataRow from '@/views/withdrawal/fragments/WithdrawalModificationDataRow.vue';

import moment from 'moment';
import 部署選択型 from '@/type/withdrawal/types/部署選択型';
import {払出修正候補検索条件型} from '@/type/withdrawal/records/modify/払出修正候補検索条件型';
import {払出修正候補検索結果レコード型, 払出修正候補検索結果型} from '@/type/withdrawal/records/modify/払出修正候補検索結果レコード型';
import {to払出修正依頼型, 払出修正依頼型} from '@/type/withdrawal/records/modify/払出修正依頼型';
import {商品区分一覧, 商品区分型} from '@/type/withdrawal/types/商品区分型';

import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';
import {払出修正候補編集レコード型, 確定対象をフィルタする} from '@/type/withdrawal/records/modify/払出修正候補編集レコード型';
import {to払出削除依頼型} from '@/type/withdrawal/records/modify/払出削除依頼型';
import 払出修正候補検索条件入力チェッカー from '@/type/withdrawal/records/modify/払出修正候補検索条件入力チェッカー';
import 払出修正候補編集入力チェッカー from '@/type/withdrawal/records/modify/払出修正候補編集入力チェッカー';
import {viewEditingStateModule} from '@/store/state/viewEditingState';

@Component({
  components: {
    ToggleButtonField,
    ButtonPanel,
    DepartmentSelector,
    SenderSelector,
    IconButton,
    Datepicker,
    NormalButton,
    AmountField,
    ConfirmDialog,
    AlertDialog,
    WithdrawalModificationDataRow,
  },
  filters: {
    日付のフォーマット(date: Date): string {
      if (!date) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
  },
})
export default class WithdrawalModification extends Vue {
  // data
  部署選択: 部署選択型 = new 部署選択型(this.ログインユーザの部署コード, this.管理者である, this.代行ログインである);

  検索条件: 払出修正候補検索条件型 = this.デフォルトの検索条件;
  検索結果に対応する検索条件: 払出修正候補検索条件型 | null = null;
  検索結果: 払出修正候補検索結果レコード型[] = [];

  編集内容: 払出修正候補編集レコード型[] = [];
  削除候補: 払出修正候補編集レコード型 | null = null;

  選択行番号: number | null = null;
  アラートメッセージ: string[] | string | null = null;

  // computed
  get ログインユーザの部署コード(): string {
    return loginModule.部署コードを取得する;
  }

  get ログインユーザの利用者コード(): string {
    return loginModule.利用者コードを取得する;
  }

  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  get 管理者である(): boolean {
    return loginModule.管理者である;
  }

  get 代行ログインである(): boolean {
    return loginModule.マスターである;
  }

  get 有効期限管理をする(): boolean {
    return loginModule.有効期限管理をする;
  }

  get 有効期限管理をしない(): boolean {
    return loginModule.有効期限管理をしない;
  }

  get 表示件数(): number {
    return this.検索結果.length;
  }

  get 商品区分一覧(): 商品区分型[] {
    return 商品区分一覧;
  }

  get 当月月初(): Date {
    const today = new Date();
    today.setDate(1);
    return today;
  }

  get デフォルトの検索条件(): 払出修正候補検索条件型 {
    return {
      払出年月日FROM: this.当月月初,
      払出年月日TO: null,
      メーカー名: '',
      商品名カナ: '',
      商品区分: null,
      利用者コード: this.管理者である ? null : this.ログインユーザの利用者コード,
      部署コード: this.部署選択.部署コード,
    };
  }

  @Watch('編集内容', {deep: true})
  リストが変更された() {
    viewEditingStateModule.画面の編集を開始する();
  }

  async 編集を破棄して検索を実行するハンドラ() {
    this.$modal.hide('編集中検索確認ダイアログ');
    await progress(this.検索処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }
  編集中検索確認ダイアログを閉じる() {
    this.$modal.hide('編集中検索確認ダイアログ');
  }

  // methods
  部署を確定する(): void {
    if (this.部署選択.部署コード == null) {
      this.showAlert('部署を選択してください');
      return;
    }
    this.部署選択.確定する();
  }

  クリア確認ダイアログを閉じる(): void {
    this.$modal.hide('クリア確認ダイアログ');
  }

  削除確認ダイアログを開く(): void {
    this.$modal.show('削除確認ダイアログ');
  }

  削除確認ダイアログを閉じる(): void {
    this.$modal.hide('削除確認ダイアログ');
  }

  クリアメッセージ(): string {
    if (viewEditingStateModule.画面を編集中である) {
      return '編集中のデータは破棄されますが、よろしいですか？';
    }
    return 'クリアしますか？';
  }

  async クリア確認する() {
    await this.クリアする()
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  クリア確認ダイアログを開く() {
    this.$modal.show('クリア確認ダイアログ');
  }

  async クリアする(): Promise<void> {
    this.部署選択 = new 部署選択型(this.ログインユーザの部署コード, this.管理者である, this.代行ログインである);

    this.検索条件 = this.デフォルトの検索条件;
    this.検索結果に対応する検索条件 = null;
    this.検索結果 = [];

    this.編集内容 = [];
    this.削除候補 = null;

    this.選択行番号 = null;
    this.アラートメッセージ = null;
    this.クリア確認ダイアログを閉じる();
  }

  検索条件入力エラー判定表示(項目名: string): any {
    return {'input-error': this.検索条件入力エラー判定(項目名)};
  }

  検索条件入力エラー判定(項目名: string): boolean {
    const checker = new 払出修正候補検索条件入力チェッカー(this.検索条件);
    return checker.hasError(項目名);
  }

  行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  async 払出を検索する(): Promise<void> {
    this.検索条件.部署コード = this.部署選択.部署コード;

    const checker = new 払出修正候補検索条件入力チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }

    if (viewEditingStateModule.画面を編集中である) {
      this.$modal.show('編集中検索確認ダイアログ');
      return;
    }

    await progress(this.検索処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  async 検索処理(): Promise<void> {
    await api.払出を検索する(this.検索条件)
      .then((response: 払出修正候補検索結果型) => {
        this.検索結果 = response.払出修正商品検索結果レコード一覧;
        this.選択行番号 = null;
        if (this.検索結果.length === 0) {
          this.編集内容 = [];
          this.検索結果 = [];
          this.showAlert('検索結果が0件です。');
          return;
        }
        this.検索結果に対応する検索条件 = {...this.検索条件};
        this.編集内容 = this.検索結果.map((record) => 払出修正候補編集レコード型.作成する(this.検索条件.部署コード, record));
        if (response.アラートメッセージ) {
          this.showAlert(response.アラートメッセージ);
        }
      }).catch((error: any) => {
        this.showAlert(error.data.message);
      });
  }

  async 入力を確定して保存する(): Promise<void> {
    const 修正対象 = 確定対象をフィルタする(this.編集内容);
    if (修正対象.length === 0) {
      this.showAlert('払出修正の確定対象が存在しません');
      return;
    }

    const checker = new 払出修正候補編集入力チェッカー();
    checker.validateList(this.編集内容, this.バラ管理である);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }

    const 修正依頼: 払出修正依頼型[] = 修正対象.map((record) => to払出修正依頼型(record));
    const 修正処理 = async (): Promise<void> => {
      await api.払出を修正する(修正依頼)
        .then(async () => {
          await this.reload();
        })
        .catch((error: any) => {
          if (error.data.errors) {
            this.showAlert(error.data.errors);
            return;
          }
          if (error.data.message && !error.data.errors) {
            this.showAlert(error.data.message);
          }
        });
    };

    await progress(修正処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  払出の削除を確認する(event: any): void {
    this.削除候補 = event.value;
    this.削除確認ダイアログを開く();
  }

  払出の削除をキャンセルする(): void {
    this.削除候補 = null;
    this.削除確認ダイアログを閉じる();
  }

  async 払出を削除する(): Promise<void> {
    if (this.削除候補 === null) {
      return;
    }
    const 削除依頼 = to払出削除依頼型(this.削除候補);

    const 削除処理 = async (): Promise<void> => {
      await api.払出を削除する(削除依頼)
        .then(async (response: void) => {
          await this.reload();
        }).catch((error: any) => {
          this.showAlert(error.data.message);
        });
      this.削除候補 = null;
    };

    await progress(削除処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
    this.削除確認ダイアログを閉じる();
  }

  async reload(): Promise<void> {
    if (this.検索結果に対応する検索条件 === null) {
      return;
    }
    this.検索条件 = this.検索結果に対応する検索条件;
    await api.払出を検索する(this.検索結果に対応する検索条件)
      .then((response: 払出修正候補検索結果型) => {
        this.検索結果 = response.払出修正商品検索結果レコード一覧;
        this.編集内容 = this.検索結果.map((record) => 払出修正候補編集レコード型.作成する(this.検索条件.部署コード, record));
      });
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('払出修正削除アラート');
  }

  // lifecycle hook
  // do nothing
}
